export default __webpack_public_path__ + "static/media/logoExtended.ca98124e.png";